import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ENVIRONMENT } from '@libs/shared/injections/window';
import { EnvironmentType } from '@libs/models/environment.type';

@Component({
  selector: 'app-loan-conditions',
  templateUrl: './loan-conditions.component.html',
  styleUrls: ['./loan-conditions.component.sass'],
  standalone: true,
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoanConditionsComponent {
  public readonly documentsUrl: string = this.environment.publicDocumentsUrl;

  constructor(@Inject(ENVIRONMENT) private environment: EnvironmentType) {}
}
